import SpinnerChase from './SpinnerChase';

type PreloaderProps = {
  className?: string;
};

const Preloader = ({ className }: PreloaderProps) => {
  return (
    <div id="preloader" className={className}>
      <div id="status">
        <SpinnerChase />
      </div>
    </div>
  );
}

export default Preloader;